import type { AccountDetailResponse } from '~/types/adminApi';
import { ELocale } from '~/types/enums';

export const account: AccountDetailResponse = {
    background: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mNkYPhfz0AEYBxVSF+FAP5FDvcfRYWgAAAAAElFTkSuQmCC',
    colorScheme: null,
    id: 1,
    locale: ELocale.CS,
    logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFUlEQVR42mNk+M9Qz0AEYBxVSF+FAAhKDveksOjmAAAAAElFTkSuQmCC',
    name: 'Jozko Mrkvicka',
    registrationLink: 'https://jozkomrkvicka.munipolis-stage.cz/registrace',
    slug: 'jozkomrkvicka',
    web: '',
    myMrLite: {
        domain: 'jozkomrkvicka',
        headScript: null,
        bodyScript: null,
    },
};
